import { render, staticRenderFns } from "./TagHistoryPopupV2.vue?vue&type=template&id=85804c60&scoped=true"
import script from "./TagHistoryPopupV2.vue?vue&type=script&lang=js"
export * from "./TagHistoryPopupV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85804c60",
  null
  
)

export default component.exports